import {
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_SUCCESS,
  UPDATE_META_EMAIL_VERIFIED,
} from "../constant";

const initialState = {
  switch_exam: true,
  metadata: {
    user: {
      email_verified: false,
    },
  },
  apiloading: false,
  packageHeader: [],
  notifications: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_SWITCH_EXAM":
      return {
        ...state,
        switch_exam: !state.switch_exam,
      };
    case "GET_META_DATA":
      return {
        ...state,
        metadata: { ...action.payload },
      };
    case UPDATE_META_EMAIL_VERIFIED:
      return {
        ...state,
        metadata: {
          ...state.metadata,
          user: {
            ...state.metadata.user,
            email_verified: action.payload,
          },
        },
      };
    case "API_LOADING":
      return {
        ...state,
        apiloading: action.payload,
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        error: action.payload,
      };
    default:
      return state;
  }
};
